import { render, staticRenderFns } from "./ChatForm.vue?vue&type=template&id=3943f00b&scoped=true&"
import script from "./ChatForm.vue?vue&type=script&lang=js&"
export * from "./ChatForm.vue?vue&type=script&lang=js&"
import style0 from "./ChatForm.vue?vue&type=style&index=0&id=3943f00b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3943f00b",
  null
  
)

export default component.exports